// // DisplayVehicles.js
// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { getFirestore, collection, getDocs } from 'firebase/firestore';
// import styles from './DisplayVehicles.module.css'; // Import your CSS module for styling
// import { useNavigate } from 'react-router-dom';

// import { getAuth } from 'firebase/auth';
// const DisplayVehicles = () => {
//   const [documentIds, setDocumentIds] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const firestore = getFirestore();
//   const navigate = useNavigate();
//   const auth = getAuth()
//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       if (!user) {
//         // If the user is not authenticated, navigate to the login page
//         navigate("/login");
//       }
//     });

//     // Cleanup the subscription when the component unmounts
//     return () => unsubscribe();
//   }, [navigate]);
//   useEffect(() => {
//     const fetchDocumentIds = async () => {
//       try {
//         const querySnapshot = await getDocs(collection(firestore, 'Localbuses'));
//         const ids = querySnapshot.docs.map((doc) => doc.id);
//         setDocumentIds(ids);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching document IDs from Firestore:', error);
//         setLoading(false);
//       }
//     };

//     fetchDocumentIds();
//   }, [firestore]);

//   return (
//     <div className={styles.container3D}> {/* Apply 3D effect styling to the container */}
//       <h2>Display College/City Buses</h2>
//       {loading ? (
//         <p>Loading...</p>
//       ) : documentIds.length > 0 ? (
//         <ul>
//           {documentIds.map((documentId) => (
//             <li key={documentId}>
//               {/* Use the `to` prop to specify the route with the documentId parameter */}
//               <Link to={`/ViewLocalBusDetails/${documentId}`}>{documentId}</Link>
//             </li>
//           ))}
//         </ul>
//       ) : (
//         <p>No vehicles found in the publicbuses collection.</p>
//       )}
//     </div>
//   );
// };

// export default DisplayVehicles;
// DisplayVehicles.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import styles from './DisplayVehicles.module.css'; // Import your CSS module for styling
import { useNavigate } from 'react-router-dom';

import { getAuth } from 'firebase/auth';

const DisplayVehicles = () => {
  const [documentIds, setDocumentIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const firestore = getFirestore();
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        // If the user is not authenticated, navigate to the login page
        navigate("/login");
      }
    });

    // Cleanup the subscription when the component unmounts
    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    const fetchDocumentIds = async () => {
      try {
        const querySnapshot = await getDocs(collection(firestore, 'Localbuses'));
        const ids = querySnapshot.docs.map((doc) => doc.id);
        setDocumentIds(ids);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching document IDs from Firestore:', error);
        setLoading(false);
      }
    };

    fetchDocumentIds();
  }, [firestore]);

  return (
    // <div className={styles.container3D}> {/* Apply 3D effect styling to the container */}
    <div className='styles.cont'>
      <h2>Display College/City Buses</h2>
      {loading ? (
        <p>Loading...</p>
      ) : documentIds.length > 0 ? (
        <table className={styles.table}>
          <thead>
            <tr>
              <th >Bus ID</th>
            </tr>
          </thead>
          <tbody>
            {documentIds.map((documentId) => (
              <tr key={documentId}>
                <td>
                  {/* Use the `to` prop to specify the route with the documentId parameter */}
                  <Link to={`/ViewLocalBusDetails/${documentId}`}>{documentId}</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No vehicles found in the publicbuses collection.</p>
      )}
     </div>
  );
};

export default DisplayVehicles;
